import React from "react"
import styles from "./styles.scss"
import SideNav from "components/SideNav"
import { getCounties, selectCountiesAsArray } from "data/counties"
import { createAd } from "data/ads"
import { connect } from "react-redux"
import AdForm from "components/AdForm"
import AdminHeader from "../../components/AdminHeader"
import { getBase64 } from "helpers"

class AdNew extends React.Component {
  constructor(props) {
    super(props)

    props.getCounties()
  }
  handleSubmit = values => {
    const adCounties = values.adCounties.map(county => ({
      countyId: county.value,
    }))

    let ad = {
      title: values.adTitle,
      body: values.adBody,
      adUrl: values.adUrl,
      isActive: values.adIsActive,
      adCounties,
    }
    values.adImage
      ? getBase64(values.adImage["0"]).then(data => {
          var bindata = data.split(",")[1]
          ad = { ...ad, image: bindata }
          this.props.createAd(ad)
        })
      : this.props.createAd(ad)
  }

  render() {
    return (
      <div className={styles.container}>
        <div className={styles.mainContent}>
          <AdminHeader />
          <div className={styles.adformWrapper}>
            <SideNav type="ads" />
            <div className={styles.adForm}>
              <h2>Skapa ny Annons</h2>
              <AdForm
                counties={this.props.counties}
                onSubmit={this.handleSubmit}
                submitText="Spara"
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  counties: selectCountiesAsArray(state, ownProps),
})

export default connect(mapStateToProps, {
  getCounties,
  createAd,
})(AdNew)



// WEBPACK FOOTER //
// src/pages/Admin/Ads/AdNew/index.jsx